import { render, staticRenderFns } from "./MainSidebarItem.vue?vue&type=template&id=f5d6842c&scoped=true&"
import script from "./MainSidebarItem.vue?vue&type=script&lang=ts&"
export * from "./MainSidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./MainSidebarItem.vue?vue&type=style&index=0&id=f5d6842c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d6842c",
  null
  
)

export default component.exports